import { JSX, ReactElement, ReactNode } from "react";
import { BaseComponent } from "../../Core/BaseComponent/BaseComponent";
import { LeftButtons } from "./LeftButtons";
import { RightButtons } from "./RightButtons";
import { ILeftButtonsProps as ILeftButtonProps } from "./LeftButtons";
import { IRightButtonsProps as IRightButtonProps } from "./RightButtons";
import React from "react";
import { GridContainer } from "../../Layout/Grid/GridContainer";

export class ButtonBar extends BaseComponent<IButtonBarProps, IButtonBarState>
{
    constructor(props: IButtonBarProps)
    {
        super(props);
        this.state = {
            hasLeftButtons: true,
            hasRightButtons: true,
        };
    }

    public componentDidMount(): void
    {
        this.checkChildren();
    }

    public componentDidUpdate(prevProps: IButtonBarProps): void
    {
        if (prevProps.children != this.props.children)
        {
            this.checkChildren();
        }
    }

    public checkChildren(): void
    {
        const { children } = this.props;
        let childrenAreValid: boolean;

        if (Array.isArray(children))
        {
            childrenAreValid = (
                children.length == 2 &&
                React.isValidElement(children[0]) && children[0].type == LeftButtons &&
                React.isValidElement(children[1]) && children[1].type == RightButtons
            );

            this.setState({
                hasLeftButtons: true,
                hasRightButtons: true,
            });
        }
        else
        {
            const elementIsValid = React.isValidElement(children);
            childrenAreValid = (elementIsValid && (children.type == LeftButtons || children.type == RightButtons));

            this.setState({
                hasLeftButtons: (elementIsValid && children.type == LeftButtons),
                hasRightButtons: (elementIsValid && children.type == RightButtons),
            });
        }

        if (!childrenAreValid)
        {
            throw new Error('The ButtonBar must contain only LeftButtons and RightButtons. If both, the LeftButtons must be first.');
        }
    }

    public render(): JSX.Element
    {
        let children = this.props.children;
        if (!this.state.hasLeftButtons || !this.state.hasRightButtons)
        {
            const buttons = React.Children.toArray(this.props.children)[0] as ReactElement<ILeftButtonProps | IRightButtonProps>
            children = [React.cloneElement(buttons, { fullWidth: true })];
        }

        return (
            <GridContainer spacing="md">
                {children}
            </GridContainer>
        );
    }
}

export interface IButtonBarProps
{
    children: ReactNode;
}

export interface IButtonBarState
{
    hasLeftButtons: boolean;
    hasRightButtons: boolean;
}
